<h2 mat-dialog-title>Atenção</h2>
<mat-dialog-content>
  <h5 mat-dialog-subtitle>
    O valor informado (R$ {{ data.valueInformed | number:'1.2-2' }}) difere do valor provisionado
    (R$ {{ data.valueProvisioned | number:'1.2-2' }}). Como deseja prosseguir?
  </h5>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-button (click)="onOptionClick(options.DISCOUNT)" [disabled]="!isDiscount">Aplicar desconto</button>
  <button mat-button (click)="onOptionClick(options.SURCHARGE)" [disabled]="!!isDiscount">Aplicar juros/acréscimo</button>
  <button mat-button (click)="onOptionClick(options.PARTIAL)">Manter saldo em aberto</button>
  <button mat-button (click)="onOptionClick(options.FINALIZE)">Zerar o saldo do título</button>
</mat-dialog-actions>

<mat-dialog-actions align="end">
  <button class="danger" mat-button (click)="onCancel()">Cancelar</button>
</mat-dialog-actions>
